import { HOUR_IN_MS, MINUTE_IN_MS } from "@tradingApp/constants";

/**
 * @example
 * const hoursLeft = countdownHours(1, "hh:mm:ss");
 */
export function countdownHours(
  intervalHours: number,
  format = "hh:mm:ss",
): string {
  const now = new Date();
  const nextDate = new Date();
  nextDate.setHours(now.getHours() + intervalHours);
  nextDate.setMinutes(0);
  nextDate.setSeconds(0);
  nextDate.setMilliseconds(0);
  const difference = nextDate.getTime() - now.getTime();

  let hours = "00";
  let minutes = "00";
  let seconds = "00";

  if (difference > 0) {
    const hoursRaw = Math.floor((difference / HOUR_IN_MS) % 24);
    const minutesRaw = Math.floor((difference / MINUTE_IN_MS) % 60);
    const secondsRaw = Math.floor((difference / 1000) % 60);
    hours = addLeadingZero(hoursRaw);
    minutes = addLeadingZero(minutesRaw);
    seconds = addLeadingZero(secondsRaw);
  }

  return format
    .replace("hh", hours)
    .replace("mm", minutes)
    .replace("ss", seconds);
}

function addLeadingZero(value: number): string {
  return value.toString().padStart(2, "0");
}
